import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Input, TextArea } from 'semantic-ui-react'
import { setMockResponse } from './actions/qryInputActions';
import store from './store';    

export class mockResponse extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            mockingData: false
        }
    }

    saveMockResponseSpecial = (extraParameterGeneric)=>{
        this.setState({"errorMessage": ''});
        this.setState({"mockingData": true})
        let payload = {
            qryType: this.props.qryType,
            requestid: this.props.requestId,
            searchParam: this.props.searchParam,
            recordList: null,
            extraParameterGeneric: extraParameterGeneric,
        }
        window.mockResponseCalled = true;
        store.dispatch(this.props.setMockResponse(null, payload));
        
    }

    saveMockResponse = () =>{
        let errorMsg = "";
        let mockdata = document.getElementById("mockdata").value.trim();
        if(mockdata){
            let validate = this.validateMockData(mockdata);
            if(validate.errorList.length){
                this.setState({"errorMessage": validate.errorList});
            }else{
                this.setState({"errorMessage": ''});
                this.setState({"mockingData": true})
                let payload = {
                    qryType: this.props.qryType,
                    requestid: this.props.requestId,
                    searchParam: this.props.searchParam,
                    recordList: validate.recordList
                }
                window.mockResponseCalled = true;
                store.dispatch(this.props.setMockResponse(validate.recordList, payload));
            }
        }
    };

    clearResponse = () => {
        document.getElementById("mockdata").value = "";
    }

    validateMockData = (mockdata) => {
        let recordList = [];
        let errorList = [];
        if(mockdata.charAt(0) === '[' && mockdata.charAt(mockdata.length-1) === ']'){
            mockdata = mockdata.substr(1, mockdata.length-2);
        }
        let copiedText = mockdata.replace(/(\r\n|\n|\r)/gm,"");
        if(copiedText.length > 80){
            let confrm = window.confirm("Are you sure to save this record ? Changes can not be undone");
            if(confrm){
                let pastedData = copiedText.replace(/\]\[/g, "%%");
                let EdiData = pastedData.split("%%");
                EdiData.map((item, index)=>{
                    if(item.length!=80){
                        errorList.push({recordNumber: index+1, record: item})
                    }else{
                        recordList.push({"record": item});
                    }
                })
                return {
                    errorList,
                    recordList
                }
            }    
        }else{
            errorList.push({recordNumber: 1, record: "Record length is less than 80"})
            return {
                errorList,
                recordList
            }
        }
        
    }
    
    render() {
        window.console.log("this.propsxx",this)
        window.console.log("ythis.propsxx",this.props)
        window.console.log("zthis.propsxx",this.state)
        let fullEntryNumber = this.props.entryNumber;
        let filerCode = "";
        try{
            if(this.props.kxUser.userInfo.brokerAdditionalInfo.filerCode && !filerCode){
                filerCode = this.props.kxUser.userInfo.brokerAdditionalInfo.filerCode ;
            }
        } catch(e){}
        try{
            if(this.props.qryOutput.responseParams.filerCode && !filerCode){
                filerCode = this.props.qryOutput.responseParams.filerCode;
            }
        } catch(e){}
        try{
            if(this.props.filerCode && !filerCode){
                filerCode = this.props.filerCode;
            }
        } catch(e){}
        if(!filerCode && fullEntryNumber && fullEntryNumber.length> 5){
            filerCode = fullEntryNumber.slice(0,3)
        }    
        let entryNumberLast8 = "";
        if(fullEntryNumber && fullEntryNumber.length == 11){
            entryNumberLast8 = fullEntryNumber.slice(3,11)
        }
        if(!entryNumberLast8){
            entryNumberLast8 = "DEFGHIJK"
        }

        if(!filerCode)filerCode="ABC"
        /*
        BONUS MID MOCKS

        'A2809S1F      010222     $R                                KX-E3C4-7            '
'B  1704BII$R                                               ZBNF0UVTWM5AYB8QQQGK '
'$5U00001CNLONGHAI                                                               '
'$6                               CNLON952ZHA                                    '
'Y  1704BII$R                                                                    '
'Z2809S1F      010222                                                            '

'A2809S1F      010122     $R                                KX-B7B1-365          '
'B  3001E6G$R                                               3H4HQDYWI0HXET2PVCXX '
'$5E00001MYT A FURNITURE INDUSTRIES                                              '
'$6                               MYTAFUR3JOH                                    '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  3001E6G$R                                                                    '
'Z2809S1F      010122                                                            '

'A2809S1F      010124     $R                                KX-J4I5-1            '
'B  2809N3K$R                                               QNN4YOTZLEC3CZBWCLSV '
'$5E00001CNSHANGHAI YUHAI EXHIBITION DISPLAY COMPANY                             '
'$6                               CNSHAYUHSHA      201400                        '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  2809N3K$R                                                                    '
'Z2809S1F      010124                                                            '

'A2809S1F      010222     $R                                KX-W2H6-6674         '
'B  3001E6G$R                                               BWWTAW3WYB9CBHJHJJMH '
'$5E00001VNHAN DUE MANUFACTURE FURNITURE                                         '
'$6                               VNHANDUE1VIN                                   '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  3001E6G$R                                                                    '
'Z2809S1F      010222                                                            '

'A2809S1F      010223     $R                                KX-X5B5-1            '
'B  1704BII$R                                               OA9FBVXNLQIZ7VHSLWXV '
'$5E00001VNHOANG HA JOINT STOCK COMPANY                                          '
'$6                               VNHOAHAVAN                                     '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  1704BII$R                                                                    '
'Z2809S1F      010223                                                            '

'A2809S1F      010122     $R                                KX-G4B9-1610         '
'B  1704BII$R                                               QISJ20YVV1DU1DGOOZUS '
'$5E00001CNANJI WANHE FURNITURE CO LTD                                           '
'$6                               CNANJWAN1ANJ                                   '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  1704BII$R                                                                    '
'Z2809S1F      010122                                                            '

'A2809S1F      010222     $R                                KX-H6D2-30           '
'B  1704BII$R                                               YVYP640C79Z15NJXSUGG '
'$5E00001VNGOODWOOD INTERIORS LTD                                                '
'$6                               VNGOOINT3161THU                                '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  1704BII$R                                                                    '
'Z2809S1F      010222                                                            '

'A2809S1F      010222     $R                                KX-U4A7-107          '
'B  1704BII$R                                               Y43O4DB7Y0OZVVDX0UR0 '
'$5U00001CNBAIXING SHUN CHENG FURNITURE                                          '
'$6                               CNBAISHUHUI                                    '
'Y  1704BII$R                                                                    '
'Z2809S1F      010222                                                            '

'A2809S1F      010123     $R                                KX-T6D4-1290         '
'B  1704BII$R                                               SYM9XNNFU7N85TISIMT5 '
'$5E00001CNHK LIFENG FURNITURE INDUSTRIAL CO LTD                                 '
'$6                               CNHKLIF73DON                                   '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  1704BII$R                                                                    '
'Z2809S1F      010123                                                            '

'A2809S1F      010222     $R                                KX-O3A5-645          '
'B  1704BII$R                                               FNRK2PP70I3YQTKBMEDA '
'$5E00001INM S ND INTERNATIONAL                                                  '
'$6                               INMSND2PAN                                     '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  1704BII$R                                                                    '
'Z2809S1F      010222                                                            '

'A2809S1F      010222     $R                                KX-J0E4-46           '
'B  1704BII$R                                               AXGIOVMZEUY7F954YRDF '
'$5E00001CNYIMU MINHONG TRADING CO LTD                                           '
'$6                               CNYIMMIN1YIW                                   '
'$7B22 MID ALREADY EXISTS                                                        '
'Y  1704BII$R                                                                    '
'Z2809S1F      010222                                                            '

*/
        return (
            <React.Fragment>
                {this.props.qryType=="BOL" && <React.Fragment>
                <Button style={{"marginLeft": "40%"}} 
                    onClick={()=>{this.saveMockResponseSpecial({
                        "billMatch":1,
                        timestamp:Date.now(),
                        doctype: 'DOC_CR_BOL_QUERY_RESPONSE',
                        shipmentid:this.props.shipmentId,
                    })}} 
                    className="ui green button">Mock No Bill Match</Button><br/><br/>
                <Button style={{"marginLeft": "40%"}}
                    onClick={()=>{this.saveMockResponseSpecial({
                        "billMatch":3,
                        timestamp:Date.now(),
                        doctype: 'DOC_CR_BOL_QUERY_RESPONSE',
                        shipmentid:this.props.shipmentId,
                    })}} 
                    className="ui green button">Mock Bill Match</Button><br/><br/>
                </React.Fragment>}
                <Modal
                    className={`mockResponseModal`}
                    closeIcon
                    trigger={<Button style={{"marginLeft": "40%"}} className="ui green button">Mock Response</Button>}
                    header='Mock Response!'
                    content={
                        <div style={{"margin": "10px"}}>
                            {
                                this.state.errorMessage && 
                                <div className={`errorMsgList`}>
                                <div><strong>Following record length is not 80</strong></div>  
                                {
                                    this.state.errorMessage.map((item)=>{
                                        return (<div>{item.recordNumber} - {item.record}</div>)
                                    })
                                }
                                </div> 
                            }  
                            <div>
                <style type="text/css">{`
                    .mockbuttonss button {
                        min-width:100px;
                        margin: 1px !important;
                    }
                `}</style>
                                <TextArea placeholder='[    ------ ADD MOCK RESPONSE DATA HERE ----   ]'  
                                    style={{"margin": "10px", "width": "97%", "height": "200px"}} 
                                    id='mockdata'
                                    autoFocus       
                                ></TextArea>
                                <div className="mockbuttonss">
                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      112219     JD                                                     ]
[B  2801E6GJD                                               ${this.props.requestId} ]
[JB${filerCode}  ${entryNumberLast8}00100111119040516PM       Y2100920 PNDING                        ]
[JC2111211901111319 21122190            0 NO                                     ]
[JD2111319000000000000000000000000000000000000000000000000000000000000           ]
[JE00000005241680000000000000000000000988400000000000000000000000000             ]
[10AE6G  00019138 2809            0111 XA          3112119            N          ]
[1182-20473090082-204730900               111119111119       CA                  ]
[20SMMB2811111119Y549ARISTOMENIS                                                 ]
[21009E                                                                          ]
[2200000138CTN                                                                   ]
[23MONEYHKGVL1117300                                                             ]
[23HSMMBSSZX4735034                                                              ]
[318B 388                                                                        ]
[4A00001                                                                         ]
[40  001 CNCN102519                 157078       707    N                        ]
[47MHKGOLBAS3673CEN                                                              ]
[47S82-204730900                                                                 ]
[5099038804        69900          0                                              ]
[509401614011        000       2796         2000NO                               ]
[62499     969                                                                   ]
[62501     350                                                                   ]
[4A00002                                                                         ]
[40  002 CNCN102519                 157078      4704    N                        ]
[47MHKGOLBAS3673CEN                                                              ]
[47S82-204730900                                                                 ]
[5099038803       453775          0                                              ]
[509401616011        000      18151        11700NO                               ]
[62499    6288                                                                   ]
[62501    2269                                                                   ]
[4A00003                                                                         ]
[40  003 CNCN102519                 157078        13    N                        ]
[47MHKGOLBAS3673CEN                                                              ]
[47S82-204730900                                                                 ]
[5099038802          400          0                                              ]
[503919102010        093         16          100M2         1300KG                ]
[62499     006                                                                   ]
[62501     002                                                                   ]
[89501       2621499       7263                                                  ]
[90     524168        9884         000         000         000           0       ]
[Y  2801E6GJD00038                                                               ]
[Z2809S1F      112219                                                            ]`

                                }}>MOCK ES DATA</button>&nbsp;


                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      101019     C1                                ${(this.props.shipmentId||window.shipmentId||"").padEnd(18," ")}   ]
[B  2801E6GC1                                               ${this.props.requestId} ]
[WR1                                       HLCURIO GRANDE EXPRESS  004W 031320   ]
[WR4            LIV200235807                        00000025PCS  HLCU    MN1     ]
[WR5022120110569 BILL ON FILE                                     25       001   ]
[WN1            5301                        41352022520                          ]
[Y  2801E6GC100004                                                               ]
[Z2809S1F      101019                                                            ]`

                                }}>MOCK BOL QUERY 2</button>&nbsp;


                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      122319     KR                                                     ]
[B  2809E6GKR                                               ${this.props.requestId} ]
[K177-0136143001ZINUS, INC.                     353A003300000990007081919C000UK2 ]
[K2                                           Y Y A                              ]
[K3SOUTH X , FIRST LANE            DELHI                                         ]
[K4                                NEW DELHI            DL110025                 ]
[K5SOUTH Y , SECOND LANE           DELHI IND                                     ]
[K6                                LUCKNOW              LK112225                 ]
[K7                               CEE008 CONSUMER PRODUCTS AND MASS MER          ]
[K8IN2CHANDISING                                                                 ]
[Y  2809E6GKR00004                                                               ]
[Z2809S1F      122319                                                            ]`

                                }}>MOCK IMPORTER</button>&nbsp;


                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      101019     C1                                                     ]
[B  2801E6GC1                                               ${this.props.requestId} ]
[WO102704E6G  00016035 0176-056349300COSUEVER LUCENT         873E 093019         ]
[WO40MCOSU6222011130                                                             ]
[WO40HEFSVMZ011130B                                         00000019PKG  00000019]
[WO50100119104995BILL ARRIVED                                                    ]
[WO60100119104998RELEASED                                09301901                ]
[WO60100119104901ONE USG                                                         ]
[Y  2801E6GC100006                                                               ]
[Z2809S1F      101019                                                            ]`

                                }}>MOCK CR</button>&nbsp;

<button className="ui error button" onClick={()=>{
document.getElementById("mockdata").value = `[A2809S1F      051121     ER                                                     ]
[B  52018AGER                                               ${this.props.requestId} ]
[JB${filerCode}  ${entryNumberLast8}00200120420042435PM       Y2102221 PNDING                        ]
[JC211207200111${new Date().getFullYear()} 2120720             0 NO                                     ]
[JD2112020000000000000000000000000000000000000000000000000000000000000           ]
[JE00000000715180000000000000000000001800900000000000000000000000000             ]
[Y  52018AGER00008                                                               ]
[Z2809S1F      051121                                                            ]`

}}>MOCK ES</button>&nbsp;



<button className="ui error button" onClick={()=>{
document.getElementById("mockdata").value = `[A2809S1F      111423     ER                                ${(this.props.shipmentId||window.shipmentId||"").padEnd(18," ")}   ]
[B  4601217ER                                               ${this.props.requestId} ]
[JB${filerCode}  ${entryNumberLast8}00200120420042435PM       Y2102221 PNDING                        ]
[JC211207200111${new Date().getFullYear()} 2120720             0 NO                                     ]
[JD2112020000000000000000000000000000000000000000000000000000000000000           ]
[JE00000000715180000000000000000000001800900000000000000000000000000             ]
[JF16-10908090001        4701070722                                              ]
[JG    AAOCEE001001                                                              ]
[JH            072022                                                            ]
[JI457Y8BN22C0011OW                                                              ]
[JL08192200000083697                                                             ]
[JM00100000078738                                                                ]
[JM49900000004959                                                                ]
[Y  4601217ER00011                                                               ]
[Z2809S1F      111423                                                            ]`

}}>MOCK ESv2</button>&nbsp;



                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      051923     HY                                                     ]
[B  2809S1FHY                                               ${this.props.requestId} ]
[W19506996080 0701209999991NO       7OTHR GYM/SPORT EQUIP;PARTS&ACC000000000000  ]
[W295069960800000040000000000000000000000000000000000400000000000000000001       ]
[W39506996080TH                                 1    A*D E J P S AUBHCLCOILJOKRMA]
[WD9506996080OMPAPESG                                                            ]
[W095069960800519239506996080RANGE INCLUDES 1 RECORDS                            ]
[Y  2809S1FHY                                                                    ]
[Z2809S1F      051923                                                            ]`

                                }}>MOCK HTS</button>&nbsp;


<button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      011520     MY                                ${(this.props.shipmentId||window.shipmentId||"").padEnd(18," ")}   ]
[B  2809S1FMY                                               ${this.props.requestId} ]
[$1HKGUACHE10HON                                                                 ]
[$2    HKGUAN CHENG INDUSTRIAL (HK) LIMITED                                      ]
[$3                              RM D 10/F TOWER A BILLION CTR 1 WANG KWONG      ]
[$4RD                                                 HONG KONG                  ]
[$5                                                                              ]
[Y  2809S1FMY                                                                    ]
[Z2809S1F      011520                                                            ]`

                                }}>MOCK MID</button>&nbsp;
                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      010222     $R                                ${(this.props.shipmentId||window.shipmentId||"").padEnd(18," ")}   ]
[B  1704BII$R                                               ${this.props.requestId} ]
[$5U00001CNLONGHAI                                                               ]
[$6                               CNLON952ZHA                                    ]
[Y  1704BII$R                                                                    ]
[Z2809S1F      010222                                                            ]`

                                }}>MOCK MID ADD</button>&nbsp;
                                


                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      122319     KR                                                     ]
[B  2809E6GKR                                               ${this.props.requestId} ]
[K177-0136143001ZINUS, INC.                     353A003300000990007081919C000UK2 ]
[K2                                           Y Y A                              ]
[K7                               CEE008 CONSUMER PRODUCTS AND MASS MER          ]
[K8IN2CHANDISING                                                                 ]
[Y  2809E6GKR00004                                                               ]
[Z2809S1F      122319                                                            ]`

                                }}>MOCK IMPORTER2</button>&nbsp;


                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      011520     AC                                                     ]
[B  2809E6GAC                                               ${this.props.requestId} ]
[RAA570075000            PLASTIC DECORATIVE RIBBON      CN AC 032219             ]
[RBA5700750001 CERTAIN PLASTIC DECORATIVE RIBBON                                 ]
[REA570075000E&C VII             CUSTOMS UNIT        2024820984    2024823577    ]
[RFA570075000 080818 037004                                        080818        ]
[RGA570075000032219ORDER                                   84FR10786 032619      ]
[RGA570075000032119ORDER                                   84FR10786 032619032619]
[RGA570075000032119AMENDED FINAL DOC             AFFIRMATIV84FR10786 032619      ]
[RGA570075000032119FINAL ITC                     AFFIRMATIV84FR10531 032619      ]
[RGA570075000032119GAP PERIOD END                                    032619      ]
[RGA570075000020419GAP PERIOD BEGIN                                  020519      ]
[RGA570075000020119FINAL DOC                     AFFIRMATIV84FR1055  020119      ]
[RGA570075000080818PRELIM DOC                    AFFIRMATIV83FR39058 080818      ]
[RGA570075000021618PRELIM ITC                    AFFIRMATIV83FR7077  080818      ]
[RGA570075000012318INITIATION                              83FR3126  012418012418]
[RGA570075000011618INITIATION                              83FR3126  012418      ]
[RHA570075000 032119 CASH ONLY  032619                                           ]
[RHA570075000 020419 N/A        020519                                           ]
[RHA570075000 080818 CASH ONLY  080818                                           ]
[RIA570075000 6307909889012418                                                   ]
[RJA570075000 032119 START 032619                                                ]
[RJA570075000 020419 STOP  020519                                                ]
[RJA570075000 080818 START 080818                                                ]
[RAA570075002            PLASTIC DECORATIVE RIBBON      CN AC 032219             ]
[RBA5700750021 CERTAIN PLASTIC DECORATIVE RIBBON                                 ]
[RCA5700750021                NINGBO JUNLONG CRAFT GIFT CO., LTD.                ]
[RDA5700750021                NINGBO JUNLONG CRAFT GIFT CO., LTD.                ]
[REA570075002E&C VII             CUSTOMS UNIT        2024820984    2024823577    ]
[RFA570075002 032119 013207                                        032619        ]
[RFA570075002 020119 005421                                        020119        ]
[RFA570075002 080818 004516                                        080818        ]
[RGA570075002032219ORDER                                   84FR10786 032619      ]
[RGA570075002032119ORDER                                   84FR10786 032619032619]
[RGA570075002032119AMENDED FINAL DOC             AFFIRMATIV84FR10786 032619      ]
[RGA570075002032119FINAL ITC                     AFFIRMATIV84FR10531 032619      ]
[RGA570075002032119GAP PERIOD END                                    032619      ]
[RGA570075002020419GAP PERIOD BEGIN                                  020519      ]
[RGA570075002020119FINAL DOC                     AFFIRMATIV84FR1055  020119      ]
[RGA570075002080818PRELIM DOC                    AFFIRMATIV83FR39058 080818      ]
[RGA570075002021618PRELIM ITC                    AFFIRMATIV83FR7077  080818      ]
[RGA570075002012318INITIATION                              83FR3126  012418012418]
[RGA570075002011618INITIATION                              83FR3126  012418      ]
[RHA570075002 032119 CASH ONLY  032619                                           ]
[RHA570075002 020419 N/A        020519                                           ]
[RHA570075002 080818 CASH ONLY  080818                                           ]
[RIA570075002 6307909889012418                                                   ]
[RJA570075002 032119 START 032619                                                ]
[RJA570075002 020419 STOP  020519                                                ]
[RJA570075002 080818 START 080818                                                ]
[RAC570075003            PLASTIC DECORATIVE RIBBON      CN AC 032219             ]
[RBC5709530031 NARROW WOVEN RIBBONS WITH WOVEN SELVEDGE                          ]
[RDC5709530031                YANGZHOU BESTPAK GIFTS & CRAFTS CO., LTD           ]
[REC570953003                    CUSTOMS UNIT        2024820984    2024823577    ]
[RFC570953003 122914 008849                                        010715        ]
[RGC570953003090110ORDER                                             090110      ]
[RGC570953003071910FINAL DOC                     AFFIRMATIV          090110      ]
[RGC570953003121409PRELIM DOC                                        080609      ]
[RGC570953003080609INITIATION                                        080609      ]
[RHC570953003 122914 CASH ONLY  010715                                           ]
[RIC570953003 6307909889021410                                                   ]
[RJC570953003 122914 START 010715                                                ]
[Y  2809E6GAC00753                                                               ]
[Z2809S1F      011520                                                            ]`

                                }}>MOCK ADCVD</button>&nbsp;


                                <button className="ui error button" onClick={()=>{
                                    document.getElementById("mockdata").value = `[A2809S1F      051121     JD                                                     ]
[B  52018AGJD                                               ${this.props.requestId} ]
[JB${filerCode}  ${entryNumberLast8}00200120420042435PM       Y2102221 PNDING                        ]
[JC211207200111${new Date().getFullYear()} 2120720             0 NO                                     ]
[JD2112020000000000000000000000000000000000000000000000000000000000000           ]
[JE00000000715180000000000000000000001800900000000000000000000000000             ]
[Y  52018AGJD00008                                                               ]
[Z2809S1F      051121                                                            ]`

                                }}>MOCK PSC</button>&nbsp;

                                
<button className="ui error button" onClick={()=>{
    document.getElementById("mockdata").value = `[A2809S1F      021523     C1                                                     ]
[B  2809S1FC1                                               ${this.props.requestId} ]
[WR1                                       EGLVCOSCO NETHERLANDS   052E 092122   ]
[WR2                                                                         WAN2]
[WR4526561195   149205802265                        00000948PKG  EGLV    MY1     ]
[WR4526561210   149205802265                        00000948PKG  EGLV    MY1     ]
[WR4526561206   149205802265                        00000948PKG  EGLV    MY1     ]
[WR4526561162   149205802265                        00000948PKG  EGLV    MY1     ]
[WR4526561184   149205802265                        00000948PKG  EGLV    MY1     ]
[WR4526561173   149205802265                        00000948PKG  EGLV    MY1     ]
[WR4908139186   149205802265                        00000948PKG  EGLV    MY1     ]
[WR5083022032969 BILL ON FILE                                     948      001   ]
[WR508302205313Z BOL MATCHED TO ISF                               0        002   ]
[WR5083022054254 CARRIER BILL AMENDMENT - DELETE                  948      003   ]
[WR5083022054255 CARRIER BILL AMENDMENT - ADD                     948      004   ]
[WR508302209413Z BOL MATCHED TO ISF                               0        005   ]
[WR508302211403Z BOL MATCHED TO ISF                               0        006   ]
[WR508302212503Z BOL MATCHED TO ISF                               0        007   ]
[WR508302212573Z BOL MATCHED TO ISF                               0        008   ]
[WR508302213583Z BOL MATCHED TO ISF                               0        009   ]
[WR508302214133Z BOL MATCHED TO ISF                               0        010   ]
[WR508302216523Z BOL MATCHED TO ISF                               0        011   ]
[WR508302216583Z BOL MATCHED TO ISF                               0        012   ]
[WR5083022213854 CARRIER BILL AMENDMENT - DELETE                  948      013   ]
[WR5083022213955 CARRIER BILL AMENDMENT - ADD                     948      014   ]
[WR508312212223Z BOL MATCHED TO ISF                               0        015   ]
[WR508312216003Z BOL MATCHED TO ISF                               0        016   ]
[WR5090522214254 CARRIER BILL AMENDMENT - DELETE                  948      017   ]
[WR5090522214255 CARRIER BILL AMENDMENT - ADD                     948      018   ]
[WR509192218031J IN-BOND MOVEMENT  AUTHORIZED                     6        019   ]
[WR509202212371C ENTER AND RELEASED GENERAL EXAM                  80       020   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        021   ]
[WR509222211151W PERMIT TO TRANSFER AUTHORIZED                    948      022   ]
[WR509222212441C ENTER AND RELEASED GENERAL EXAM                  265      023   ]
[WR509222219171J IN-BOND MOVEMENT  AUTHORIZED                     35       024   ]
[WR509222219171J IN-BOND MOVEMENT  AUTHORIZED                     1        025   ]
[WR509222219171J IN-BOND MOVEMENT  AUTHORIZED                     315      026   ]
[WR509222219171J IN-BOND MOVEMENT  AUTHORIZED                     19       027   ]
[WR509222219171J IN-BOND MOVEMENT  AUTHORIZED                     25       028   ]
[WR509222219171J IN-BOND MOVEMENT  AUTHORIZED                     9        029   ]
[WR509222219191C ENTER AND RELEASED GENERAL EXAM                  35       030   ]
[WR5092722091611 ARRIVE IN-BOND AT DESTINATION - COMPLETE         6        031   ]
[WR509272220201C ENTER AND RELEASED GENERAL EXAM                  113      032   ]
[WR509272220381C ENTER AND RELEASED GENERAL EXAM                  80       033   ]
[WR5092922120951 EXPORT OF IN-BOND - BILL OF LADING               6        034   ]
[WR5093022160818 MASTER IN-BOND ADVISORY                          1        035   ]
[WR509302216081C ENTER AND RELEASED GENERAL EXAM                  1        036   ]
[WR5100322050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         1        037   ]
[WR5100522153911 ARRIVE IN-BOND AT DESTINATION - COMPLETE         315      038   ]
[WR5100622050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         35       039   ]
[WR5100622050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         25       040   ]
[WR5100622050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         9        041   ]
[WR5100622142718 MASTER IN-BOND ADVISORY                          19       042   ]
[WR510062214271C ENTER AND RELEASED GENERAL EXAM                  19       043   ]
[WR51007221131BG FTZ ADMISSION ADVISORY                           315      044   ]
[WR5101122050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         19       045   ]
[WR5101122111418 MASTER IN-BOND ADVISORY                          25       046   ]
[WR510112211141C ENTER AND RELEASED GENERAL EXAM                  25       047   ]
[WR510132216551C ENTER AND RELEASED GENERAL EXAM                  315      048   ]
[WR5102722151418 MASTER IN-BOND ADVISORY                          9        049   ]
[WR510272215141C ENTER AND RELEASED GENERAL EXAM                  9        050   ]
[WN1526561195   27092709    27094101        58309090722                          ]
[WN1526561210               27091704        58309090722                          ]
[WN1526561206               27091704        58309090722                          ]
[WN1526561162               27091704        58309090722                          ]
[WN1526561184               27092304        58309090722                          ]
[WN1526561173               27094105        58309090722                          ]
[WN1908139186               27092507        58309090722                          ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2282575LAX            00000080CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     80       001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  80       002   ]
[WR508302205313Z BOL MATCHED TO ISF                               80       003   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  80       004   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  80       005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  80       006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283139ATL            00000035CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     35       001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  35       002   ]
[WR5083022050254 CARRIER BILL AMENDMENT - DELETE                  35       003   ]
[WR5083022050255 CARRIER BILL AMENDMENT - ADD                     35       004   ]
[WR508302205021Y MVOC-NVOCC BILL OF LADING MATCH                  35       005   ]
[WR5083022050254 CARRIER BILL AMENDMENT - DELETE                  35       006   ]
[WR5083022050255 CARRIER BILL AMENDMENT - ADD                     35       007   ]
[WR508302205021Y MVOC-NVOCC BILL OF LADING MATCH                  35       008   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  35       009   ]
[WR508302212573Z BOL MATCHED TO ISF                               35       010   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  35       011   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  35       012   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        013   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283244TOL            00000001PKG  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     1        001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  1        002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  1        003   ]
[WR508302214133Z BOL MATCHED TO ISF                               1        004   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  1        005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  1        006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283435LRD            00000315CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     315      001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  315      002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  315      003   ]
[WR508302209413Z BOL MATCHED TO ISF                               315      004   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  315      005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  315      006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283504LGB            00000265CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     265      001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  265      002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  265      003   ]
[WR508302216583Z BOL MATCHED TO ISF                               265      004   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  265      005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  265      006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283511CLE            00000019CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     19       001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  19       002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  19       003   ]
[WR508302211403Z BOL MATCHED TO ISF                               19       004   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  19       005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  19       006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283559LAX            00000080CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     80       001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  80       002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  80       003   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  80       004   ]
[WR508312216003Z BOL MATCHED TO ISF                               80       005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  80       006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283574ATL            00000025CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     25       001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  25       002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  25       003   ]
[WR508302212503Z BOL MATCHED TO ISF                               25       004   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  25       005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  25       006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283580LAX            00000006PKG  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     6        001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  6        002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  6        003   ]
[WR508302216523Z BOL MATCHED TO ISF                               6        004   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  6        005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  6        006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283587LAX            00000113CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     113      001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  113      002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  113      003   ]
[WR508302213583Z BOL MATCHED TO ISF                               113      004   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  113      005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  113      006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[WR1                                       EURFCOSCO NETHERLANDS   2E   091922   ]
[WR4            149205802265LZ2283768ATL            00000009CTN  EGLVEURFHY1     ]
[WR5083022045569 BILL ON FILE                                     9        001   ]
[WR508302204551Y MVOC-NVOCC BILL OF LADING MATCH                  9        002   ]
[WR508302205421Y MVOC-NVOCC BILL OF LADING MATCH                  9        003   ]
[WR508302221391Y MVOC-NVOCC BILL OF LADING MATCH                  9        004   ]
[WR508312212223Z BOL MATCHED TO ISF                               9        005   ]
[WR509052221421Y MVOC-NVOCC BILL OF LADING MATCH                  9        006   ]
[WR5092122153719 CONVEYANCE ARRIVAL                                        007   ]
[Y  2809S1FC100171                                                               ]
[Z2809S1F      021523                                                            ]`

}}>MOCK BOL M1</button>&nbsp;



<button className="ui error button" onClick={()=>{
    document.getElementById("mockdata").value = `[A2809S1F      021523     C1                                                     ]
[B  2809S1FC1                                               ${this.props.requestId} ]
[WR1                                       EGLVCSCL SPRING         049E 092622   ]
[WR2                                                                         WAN2]
[WR4755430970   141200563399                        00000861PKG  EGLV    MY1     ]
[WR4755430966   141200563399                        00000861PKG  EGLV    MY1     ]
[WR4755431014   141200563399                        00000861PKG  EGLV    MY1     ]
[WR4755431003   141200563399                        00000861PKG  EGLV    MY1     ]
[WR4755430992   141200563399                        00000861PKG  EGLV    MY1     ]
[WR4755430981   141200563399                        00000861PKG  EGLV    MY1     ]
[WR508312220313Z BOL MATCHED TO ISF                               0        001   ]
[WR5090122000969 BILL ON FILE                                     861      002   ]
[WR509012210433Z BOL MATCHED TO ISF                               0        003   ]
[WR509012211453Z BOL MATCHED TO ISF                               0        004   ]
[WR509012211533Z BOL MATCHED TO ISF                               0        005   ]
[WR509012214233Z BOL MATCHED TO ISF                               0        006   ]
[WR509012217193Z BOL MATCHED TO ISF                               0        007   ]
[WR509022211053Z BOL MATCHED TO ISF                               0        008   ]
[WR509022214183Z BOL MATCHED TO ISF                               0        009   ]
[WR5090522000954 CARRIER BILL AMENDMENT - DELETE                  861      010   ]
[WR5090522000955 CARRIER BILL AMENDMENT - ADD                     861      011   ]
[WR509062214013Z BOL MATCHED TO ISF                               0        012   ]
[WR5090722044154 CARRIER BILL AMENDMENT - DELETE                  861      013   ]
[WR5090722044855 CARRIER BILL AMENDMENT - ADD                     861      014   ]
[WR509152213313Z BOL MATCHED TO ISF                               0        015   ]
[WR509212202011C ENTER AND RELEASED GENERAL EXAM                  5        016   ]
[WR5092622142419 CONVEYANCE ARRIVAL                                        017   ]
[WR509262217351W PERMIT TO TRANSFER AUTHORIZED                    861      018   ]
[WR509272207541C ENTER AND RELEASED GENERAL EXAM                  161      019   ]
[WR509282210231C ENTER AND RELEASED GENERAL EXAM                  6        020   ]
[WR509292214021J IN-BOND MOVEMENT  AUTHORIZED                     114      021   ]
[WR509292214021J IN-BOND MOVEMENT  AUTHORIZED                     27       022   ]
[WR509292214021J IN-BOND MOVEMENT  AUTHORIZED                     27       023   ]
[WR509292214021J IN-BOND MOVEMENT  AUTHORIZED                     8        024   ]
[WR509292214021J IN-BOND MOVEMENT  AUTHORIZED                     1        025   ]
[WR509292214021J IN-BOND MOVEMENT  AUTHORIZED                     5        026   ]
[WR509292214081C ENTER AND RELEASED GENERAL EXAM                  8        027   ]
[WR509292214081C ENTER AND RELEASED GENERAL EXAM                  1        028   ]
[WR509302213261C ENTER AND RELEASED GENERAL EXAM                  507      029   ]
[WR509302217194E ENTRY CANCEL / DELETE                            6        030   ]
[WR509302217191C ENTER AND RELEASED GENERAL EXAM                  180      031   ]
[WR5100622050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         27       032   ]
[WR5100622050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         8        033   ]
[WR5100622050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         1        034   ]
[WR5100622113118 MASTER IN-BOND ADVISORY                          27       035   ]
[WR510062211311C ENTER AND RELEASED GENERAL EXAM                  27       036   ]
[WR5101022050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         5        037   ]
[WR5101122101518 MASTER IN-BOND ADVISORY                          27       038   ]
[WR510112210151C ENTER AND RELEASED GENERAL EXAM                  27       039   ]
[WR5101122161518 MASTER IN-BOND ADVISORY                          5        040   ]
[WR510112216151C ENTER AND RELEASED GENERAL EXAM                  5        041   ]
[WR5101222050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         114      042   ]
[WR5101322050011 ARRIVE IN-BOND AT DESTINATION - COMPLETE         27       043   ]
[WR5101722161418 MASTER IN-BOND ADVISORY                          114      044   ]
[WR510172216141C ENTER AND RELEASED GENERAL EXAM                  114      045   ]
[WN1755430970   27092709    27092002        57020091322                          ]
[WN1755430966               27092904        57020091322                          ]
[WN1755431014               27095501        57020091322                          ]
[WN1755431003               27095309        57020091322                          ]
[WN1755430992               27095309        57020091322                          ]
[WN1755430981               27093307        57020091322                          ]
[WR1                                       COHECSCL SPRING         049E 092422   ]
[WR4            141200563399CTSSE2084485            00000161CTN  EGLVCOHEHY1     ]
[WR5090122045169 BILL ON FILE                                     161      001   ]
[WR509012204511Y MVOC-NVOCC BILL OF LADING MATCH                  161      002   ]
[WR509012214233Z BOL MATCHED TO ISF                               161      003   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  161      004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  161      005   ]
[WR5092622080019 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       COHECSCL SPRING         049E 092422   ]
[WR4            141200563399CTSSE2085284            00000027CTN  EGLVCOHEHY1     ]
[WR5090122045869 BILL ON FILE                                     27       001   ]
[WR509012204581Y MVOC-NVOCC BILL OF LADING MATCH                  27       002   ]
[WR509012211453Z BOL MATCHED TO ISF                               27       003   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  27       004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  27       005   ]
[WR5092622080019 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       EMLTCSCL SPRING         049E 092522   ]
[WR4            141200563399TJS2208033              00000114CTN  EGLVEMLTHY1     ]
[WR5083022232669 BILL ON FILE                                     114      001   ]
[WR508312220313Z BOL MATCHED TO ISF                               114      002   ]
[WR509012200091Y MVOC-NVOCC BILL OF LADING MATCH                  114      003   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  114      004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  114      005   ]
[WR5092622080019 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       FPSLCSCL SPRING         049E 092622   ]
[WR4            141200563399FMSE22080192            00000006PKG  EGLVFPSLHY1     ]
[WR5090122012569 BILL ON FILE                                     6        001   ]
[WR509012201251Y MVOC-NVOCC BILL OF LADING MATCH                  6        002   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  6        003   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  6        004   ]
[WR509152213313Z BOL MATCHED TO ISF                               6        005   ]
[WR5092622142419 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       GLCACSCL SPRING         049E 092422   ]
[WR4            141200563399GMT1526194              00000005PKG  EGLVGLCAHY1     ]
[WR5090122061069 BILL ON FILE                                     5        001   ]
[WR509012206101Y MVOC-NVOCC BILL OF LADING MATCH                  5        002   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  5        003   ]
[WR509062214013Z BOL MATCHED TO ISF                               5        004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  5        005   ]
[WR5092622142119 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       GLCACSCL SPRING         049E 092422   ]
[WR4            141200563399GMT1526660              00000008CRT  EGLVGLCAHY1     ]
[WR5090122061069 BILL ON FILE                                     8        001   ]
[WR509012206101Y MVOC-NVOCC BILL OF LADING MATCH                  8        002   ]
[WR509012210433Z BOL MATCHED TO ISF                               8        003   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  8        004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  8        005   ]
[WR5092622142119 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       GLCACSCL SPRING         049E 092422   ]
[WR4            141200563399GMT1526733              00000027CTN  EGLVGLCAHY1     ]
[WR5090122061069 BILL ON FILE                                     27       001   ]
[WR509012206101Y MVOC-NVOCC BILL OF LADING MATCH                  27       002   ]
[WR509012211533Z BOL MATCHED TO ISF                               27       003   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  27       004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  27       005   ]
[WR5092622142119 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       GLCACSCL SPRING         049E 092422   ]
[WR4            141200563399GMT1527193              00000005PKG  EGLVGLCAHY1     ]
[WR5090122061069 BILL ON FILE                                     5        001   ]
[WR509012206101Y MVOC-NVOCC BILL OF LADING MATCH                  5        002   ]
[WR509012217193Z BOL MATCHED TO ISF                               5        003   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  5        004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  5        005   ]
[WR5092622142119 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       MOSJCSCL SPRING         049E 092422   ]
[WR4            141200563399SLTJHT220911            00000001PKG  EGLVMOSJHY1     ]
[WR5090122001769 BILL ON FILE                                     1        001   ]
[WR509012200171Y MVOC-NVOCC BILL OF LADING MATCH                  1        002   ]
[WR509022214183Z BOL MATCHED TO ISF                               1        003   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  1        004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  1        005   ]
[WR5092622080019 CONVEYANCE ARRIVAL                                        006   ]
[WR1                                       OERTCSCL SPRING         049E 092822   ]
[WR4            141200563399204702L01327            00000507CTN  EGLVOERTHY1     ]
[WR5090122000069 BILL ON FILE                                     507      001   ]
[WR509012200091Y MVOC-NVOCC BILL OF LADING MATCH                  507      002   ]
[WR509022211053Z BOL MATCHED TO ISF                               507      003   ]
[WR509052200091Y MVOC-NVOCC BILL OF LADING MATCH                  507      004   ]
[WR509072204481Y MVOC-NVOCC BILL OF LADING MATCH                  507      005   ]
[WR5091422054954 CARRIER BILL AMENDMENT - DELETE                  507      006   ]
[WR5091422055155 CARRIER BILL AMENDMENT - ADD                     507      007   ]
[WR509142205511Y MVOC-NVOCC BILL OF LADING MATCH                  507      008   ]
[WR5092622080019 CONVEYANCE ARRIVAL                                        009   ]
[Y  2809S1FC100142                                                               ]
[Z2809S1F      021523                                                            ]`

}}>MOCK BOL M2</button>&nbsp;


<button className="ui error button" onClick={()=>{
    document.getElementById("mockdata").value = `[A2809S1F      021523     C1                                ${(this.props.shipmentId||window.shipmentId||"").padEnd(18," ")}   ]
[B  2809S1FC1                                               ${this.props.requestId} ]
[WR1                                       CPRSCPRS013316361166872222351121722   ]
[WR2                                                                         B044]
[WR4V3741155559 223349988255                        00000001TNK  CPRS    0N2     ]
[WR5113022090869 BILL ON FILE                                     1        001   ]
[WR511302209081J IN-BOND MOVEMENT  AUTHORIZED                     1        002   ]
[WR5120422094202 ENTRY ADVISORY                                   1        003   ]
[WR5120422094218 MASTER IN-BOND ADVISORY                          1        004   ]
[WR5121722012296 CONVEYANCE CONSIST                                        005   ]
[WR5121722012999 DELETE CONVEYANCE CONSIST                                 006   ]
[WR5121722012996 CONVEYANCE CONSIST                                        007   ]
[WR5121722152819 CONVEYANCE ARRIVAL                                        008   ]
[WR512172215291C ENTER AND RELEASED GENERAL EXAM                  1        009   ]
[WR5121822233213 ARRIVE IN-BOND AT DESTINATION - EQUIPMEN         1        010   ]
[WN1V3741155559 09010901    09013901                                             ]
[Y  2809S1FC100014                                                               ]
[Z2809S1F      021523                                                            ]`

}}>MOCK BOL M3</button>&nbsp;
</div>
<br/><br/>
                            </div>
                            <div>
                                <Button loading={this.state.mockingData} className="ui primary button" onClick={()=>{
                                    this.saveMockResponse()
                                }   
                                }>Save</Button>
                                <Button className="ui button" onClick={this.clearResponse}>Clear</Button> 
                            </div>
                        </div>
                    }
                />
            </React.Fragment>
        )
    }
    
}

const mapDispatchToProps = {
    setMockResponse
}

const mapStateToProps = (state, props) => {
    let _state = state.QryInput || store.getState().QryInput;
    return ({
        requestId: _state.requestid,
        mockResponseRequired: _state.mockResponseRequired,
        loading: _state.loading,
        qryInput: _state.qryInput,
    })
}

export default connect(
mapStateToProps,
mapDispatchToProps
)(mockResponse)